import Vue from 'vue';
import Vuex from 'vuex';

import { AuthStore, NoticeStore, pendoPlugin } from '@kasasa/fbase-components/lib';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fiId: null,
    configVersion: null,
    isFiUser: false,
  },
  mutations: {
    fiId(state, fiId) {
      state.fiId = fiId;
    },
    configVersion(state, configVersion) {
      state.configVersion = configVersion;
    },
    isFiUser(state, isFiUser) {
      state.isFiUser = isFiUser;
    },
  },
  modules: {
    auth: AuthStore,
    notices: NoticeStore,
  },
  plugins: [pendoPlugin],
});
